import { atom } from 'recoil';

const localStorageEffect =
  (key) =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue !== null) {
      if (isNaN(savedValue)) {
        setSelf(savedValue);
      } else {
        setSelf(parseInt(savedValue));
      }
    }

    onSet((newValue, _, isReset) => {
      if (isReset) {
      }
      isReset ? localStorage.removeItem(key) : localStorage.setItem(key, newValue);
    });
  };

export const selectedPlanState = atom({
  key: 'selectedPlanState',
  default: '',
  effects: [localStorageEffect('selectedPlan')],
});
